import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAppThunkDispatch } from 'state/store';
import {
  toggleFiltersSidePanel,
  selectIsFiltersSidePanelOpen,
} from 'state/ProjectTasksList/actions/actionsSlice';
import { TaskListFilters } from 'types/store/tasksList';
import { Option } from 'utils/customTypes';
import TasksFiltersSidePanel from 'Pages/TasksListPage/components/v2/TasksFiltersSidePanel/TasksFiltersSidePanel';

interface TableFiltersProps {
  filters: TaskListFilters;
  onUpdateFilters: (filters: TaskListFilters) => void;
  typeFilterOptions?: Option[];
}

const TableFilters: FC<TableFiltersProps> = ({
  filters,
  onUpdateFilters,
  typeFilterOptions,
}) => {
  const dispatch = useAppThunkDispatch();
  const shouldDisplayFilterComponent = useSelector(
    selectIsFiltersSidePanelOpen
  );

  const toggleFilterComponent = useCallback(() => {
    dispatch(toggleFiltersSidePanel());
  }, [dispatch]);

  return (
    <TasksFiltersSidePanel
      open={shouldDisplayFilterComponent}
      onClose={toggleFilterComponent}
      filters={filters}
      onUpdateFilters={onUpdateFilters}
      isCentralizedTasksPage={false}
      typeFilterOptions={typeFilterOptions}
    />
  );
};

export default TableFilters;
